import React from 'react';

import { useMutation } from '@apollo/react-hooks';
import { Typography, Button } from '@material-ui/core';

import { SimpleInput, LineOnSidesLink } from 'components';
import { isRequired, isEmail } from 'utils/validators';
import { useField, useForm } from 'custom-hooks';
import { RESET_PASSWORD_MUTATION } from 'graphql/mutations/auth';

import useStyles from './styles';

const ResetPassword = () => {
  const classes = useStyles();

  const [isSentEmail, setIsSentEmail] = React.useState(false);

  const [resetPassword] = useMutation(RESET_PASSWORD_MUTATION, {
    onError: () => {
      emailField.setError('User with this email does not exist');
    },
    onCompleted: () => {
      setIsSentEmail(true);
    }
  });

  const resetPasswordForm = useForm({
    onSubmit: (formData, formValid) => {
      if (!formValid) return;

      resetPassword({
        variables: { email: formData.email }
      });
    }
  });

  const emailField = useField('email', resetPasswordForm, {
    defaultValue: '',
    validations: [
      formData => isRequired(formData.email, 'Email is required'),
      formData => isEmail(formData.email, 'Invalid email')
    ]
  });

  return !isSentEmail ? (
    <div className={classes.wrapper}>
      <Typography className={classes.title} variant="h1">
        Reset Password
      </Typography>
      <Typography variant="body1">
        Enter the email address you used to register and we’ll send you an email
        with instructions to reset your password.
      </Typography>
      <form onSubmit={resetPasswordForm.handleSubmit}>
        <SimpleInput
          placeholder="Email"
          className={classes.inputIndent}
          label="Email"
          value={emailField.value}
          onChange={emailField.onChange}
          errors={emailField.errors}
          errorText={emailField.errors[0]}
        />
        <Button
          type="submit"
          className={classes.button}
          variant="contained"
          color="primary"
        >
          Reset
        </Button>
      </form>
      <LineOnSidesLink path="/login">Back to Login</LineOnSidesLink>
    </div>
  ) : (
    <div className={classes.sentEmailWrapper}>
      <Typography className={classes.title} variant="h1">
        Instructions have been sent
      </Typography>
      <Typography>
        Instructions have been sent to your email, {emailField.value}. Check
        your email and follow instructions.
      </Typography>
      <div className={classes.backLogin}>
        <LineOnSidesLink path="/login"> Back to Login</LineOnSidesLink>
      </div>
    </div>
  );
};

export default ResetPassword;
